const options = {
	root: null,
	rootMargin: '0px',
	threshold: 0.1,
}

const load = (img, retryCount = 0) => {
	if (retryCount >= 10) {
		return
	}

	const src = img.getAttribute('data-src')
	const client = new XMLHttpRequest()
	client.open('HEAD', src, true)
	client.send()
	client.onreadystatechange = function() {
		if (this.readyState === this.HEADERS_RECEIVED) {
			const isPlaceholder = client.getResponseHeader('X-Placeholder') === 'true'

			if (isPlaceholder) {
				if (retryCount === 0) {
					img.src = src
				}

				window.setTimeout(() => {
					load(img, retryCount + 1)
				}, 5000)
			} else {
				img.src = src + '#' + Math.random().toString(16).substr(2)
			}
		}
	}
}

const handleIntersect = (entries, observer) => {
	entries
		.filter(entry => entry.isIntersecting !== false)
		.forEach(entry => {
			load(entry.target)
			observer.unobserve(entry.target)
		})
}

const observer = new IntersectionObserver(handleIntersect, options)

const thumb = (scope = document) => {
	Array.from(scope.querySelectorAll('img'))
		.filter(el => el.getAttribute('data-src') !== null)
		.forEach(el => {
			observer.observe(el)
		})
}

export default thumb
